// Хелперы для работы с Telegram WebApp SDK
// Намеренно НЕ применяем themeParams Telegram к нашим CSS-переменным —
// у нас собственный фирменный язык (см. index.css). Только light/dark переключение.

import { trackEvent } from "./track";

declare global {
  interface Window {
    Telegram?: {
      WebApp?: any;
    };
  }
}

export function tg(): any | null {
  return window.Telegram?.WebApp ?? null;
}

export function initTelegram() {
  const app = tg();
  if (!app) {
    // Запуск вне Telegram (preview/dev) — оставляем дефолтную light-тему
    document.documentElement.classList.remove("dark");
    return;
  }
  app.ready();
  app.expand();

  applyTheme();
  app.onEvent("themeChanged", applyTheme);
}

function applyTheme() {
  const app = tg();
  if (!app) return;
  const scheme = app.colorScheme === "dark" ? "dark" : "light";
  if (scheme === "dark") {
    document.documentElement.classList.add("dark");
    document.documentElement.dataset.theme = "dark";
  } else {
    document.documentElement.classList.remove("dark");
    document.documentElement.dataset.theme = "light";
  }
  // Установим header_color/bg_color чтобы шапка Telegram сливалась с приложением.
  if (app.setHeaderColor) {
    try {
      app.setHeaderColor(scheme === "dark" ? "#000000" : "#f2f2f7");
    } catch {}
  }
  if (app.setBackgroundColor) {
    try {
      app.setBackgroundColor(scheme === "dark" ? "#000000" : "#f2f2f7");
    } catch {}
  }
}

export function openLink(url: string) {
  // Фиксируем переход по внешней ссылке (аналитика воронки)
  trackEvent("EXTERNAL_LINK", url);
  const app = tg();
  if (app?.openLink) {
    app.openLink(url);
  } else {
    window.open(url, "_blank", "noopener");
  }
}

export function haptic(type: "light" | "medium" | "heavy" | "success" | "warning" | "error" = "light") {
  const app = tg();
  if (!app?.HapticFeedback) return;
  if (type === "success" || type === "warning" || type === "error") {
    app.HapticFeedback.notificationOccurred(type);
  } else {
    app.HapticFeedback.impactOccurred(type);
  }
}

export function getInitData(): string {
  const app = tg();
  if (app?.initData) return app.initData;
  // Dev fallback — backend в development принимает "dev"
  return "dev";
}

export function getStartParam(): string | undefined {
  const app = tg();
  return app?.initDataUnsafe?.start_param;
}

export function showAlert(message: string) {
  const app = tg();
  if (app?.showAlert) {
    app.showAlert(message);
  } else {
    alert(message);
  }
}

export function showConfirm(message: string): Promise<boolean> {
  const app = tg();
  if (app?.showConfirm) {
    return new Promise((resolve) => {
      app.showConfirm(message, (ok: boolean) => resolve(ok));
    });
  }
  return Promise.resolve(window.confirm(message));
}
